export const NotFound = () => {
  return <div>Página não encontrada</div>;
};
